import React from "react"
import { Formik, Field, Form } from "formik"
import {
    Box,
    Button,
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Input,
} from "@chakra-ui/react"

import { GridItem } from "@/components"

const GetValueForm = ({ setResponse, ...rest }) => {
    function validateKey(key) {
        let error
        if (!key) {
            error = "Key is required"
        }
        return error
    }

    return (
        <GridItem {...rest}>
            <Formik
                initialValues={{ key: "" }}
                onSubmit={async (values, actions) => {
                    const startTime = new Date().getTime()

                    const res = await fetch(`${process.env.REACT_APP_API_URL}/db/${values.key}`)

                    const endTime = new Date().getTime()
                    const rtt = endTime - startTime

                    setResponse({
                        url: res.url,
                        from: res.headers.get("response-from"),
                        lookupTime: res.headers.get("X-Response-Time"),
                        roundTripTime: rtt,
                        status: res.status,
                        statusText: res.statusText,
                        body: await res.json(),
                    })
                    actions.setSubmitting(false)
                }}
            >
                {(props) => (
                    <Form>
                        <Field name="key" validate={validateKey}>
                            {({ field, form }) => (
                                <FormControl isInvalid={form.errors.key && form.touched.key}>
                                    <FormLabel>Key</FormLabel>
                                    <Input {...field} placeholder="key" />
                                    {!(form.errors.key && form.touched.key) ? (
                                        <FormHelperText fontSize="xs" visibility="hidden">
                                            Hidden element
                                        </FormHelperText>
                                    ) : (
                                        <FormErrorMessage fontSize="xs">
                                            {form.errors.key}
                                        </FormErrorMessage>
                                    )}
                                </FormControl>
                            )}
                        </Field>
                        <Box display="flex" justifyContent="flex-end">
                            <Button isLoading={props.isSubmitting} type="submit">
                                Get
                            </Button>
                        </Box>
                    </Form>
                )}
            </Formik>
        </GridItem>
    )
}

export { GetValueForm }
